import React from "react";
import { Form, Spinner } from "react-bootstrap";
export function NewElectricityAgreementTerms({ toggleTerms, termsAccepted, authorizationGivenToAllMeteringPoints, authorizationGivenToSomeMeteringPoints, isLoading }: { 
    toggleTerms: () => void, 
    termsAccepted: boolean; 
    authorizationGivenToAllMeteringPoints: boolean;
    authorizationGivenToSomeMeteringPoints: boolean;
    isLoading : boolean;
}) {

    const getEleringAuthorizationUrl = () => {
        return `${process.env.REACT_APP_ELERING_AUTHORIZATION_URL}/grant?eic=${process.env.REACT_APP_ELERING_AUTHORIZATION_EIC}&energy_type=Electricity&redirect_uri=${process.env.REACT_APP_ELERING_AUTHORIZATION_REDIRECT_URL}&language=et`
    }

    const getAuthorizationTitle = () => {
        if(authorizationGivenToSomeMeteringPoints) return "Muuda volitusi";
        return "Anna volitus"
    }

    return (
        <div className="new-electricity-agreement__container">
            <h1>Tutvuge tingimuste ja volitustega</h1>

            <div className="new-electricity-agreement__terms-container mt-5">
                <div className="row">
                    <div className="col-12 px-lg-5">
                        <h2>Tingimused</h2>
                        <p className="new-electricity-agreement__terms__text">
                            Nõustun, et Electric Terminal OÜ saab lepingu sõlmimise eesmärgil minu andmed Eleringi riiklikust andmelaost: kliendi ja tarbimiskoha EIC kood, tarbimiskoha aadress, olemasoleva lepingu tüüp, arvesti automatiseerimise tase. Terminal töötleb Teie andmeid õigusaktidega kehtestatud korras. Lisateavet andetöötluse kohta leiate privaatsuspoliitikast.
                        </p>
                        <Form.Check
                            id='check-terms'
                            custom
                            type="checkbox"
                            label="Nõustun tingimustega"
                            className='checkbox-large mt-3'
                            onChange={toggleTerms}
                            checked={termsAccepted}
                        />                        
                    </div>
                    {
                        !authorizationGivenToAllMeteringPoints && (
                            <div className="col-12 px-lg-5 mt-5">
                                <h2>Volitused</h2>
                                <p>Tarbimiskohtade täpsema info kuvamiseks anna volitus Elering iseteeninduses.</p>
                                <div className="d-inline-block text-center mt-3">
                                    <button 
                                        onClick={() => window.open(
                                            getEleringAuthorizationUrl(), '_self'
                                        )}
                                        className="elering-auth-btn btn btn-primary btn-lg text-center"
                                        disabled={!termsAccepted}
                                    >
                                        {
                                            isLoading ? (
                                                <Spinner size={"sm"} animation={"border"} />
                                            ) : <>{getAuthorizationTitle()}</>
                                        }
                                    </button>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}